import * as Tabs$Radix from "@radix-ui/react-tabs";
import React from "react";

import styles from "./index.module.scss";

type Option = {
  value: string;
  label: string;
  disabled?: boolean;
  hidden?: boolean;
};

function Root({
  value,
  onChange,
  children,
}: {
  value: string;
  onChange?: (value: string) => void;
  children?: React.ReactNode;
}) {
  return (
    <Tabs$Radix.Root value={value} onValueChange={onChange}>
      {children}
    </Tabs$Radix.Root>
  );
}

function List({ options }: { options: Option[] }) {
  return (
    <Tabs$Radix.List className={styles.list}>
      {options.map((item, index) =>
        item.hidden ? null : (
          <Tabs$Radix.Trigger
            className={styles.trigger}
            value={item.value}
            key={index}
            disabled={item.disabled}
          >
            {item.label}
          </Tabs$Radix.Trigger>
        )
      )}
    </Tabs$Radix.List>
  );
}

function Page({
  value,
  children,
}: {
  value: string;
  children?: React.ReactNode;
}) {
  return (
    <Tabs$Radix.Content className={styles.content} value={value} forceMount>
      {children}
    </Tabs$Radix.Content>
  );
}

const PageControlV2 = { Root, List, Page };

export default PageControlV2;
